module.exports = __webpack_public_path__ + "images/file_icons_v2/heic-54754bf4ba9700ddb1b8f05f0e63ba50.svg";